import React, { useState, useEffect, useContext } from "react";
import Skeleton from "@material-ui/lab/Skeleton";
import axios from "axios";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconForwardArrow from "../../assets/images/IconForwardArrow.png";
import IconRightYellow from "../../assets/images/IconRightYellow.png";
import IconLeftYellow from "../../assets/images/IconLeftYellow.png";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconSearch13 from "../../assets/images/IconSearch13.png";
import InputAdornment from "@material-ui/core/InputAdornment";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { useHistory } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import RefreshToken from "../../components/RefreshToken";
import { TransferContext } from "../../context/TransferContext";

const useStyles = makeStyles((theme) => ({
  marginBottomStyle: {
    marginBottom: "20px",
  },

  rightAlign: {
    textAlign: "right",
  },

  inputStyle2: {
    borderRadius: "8px",
    // "& .MuiInputBase-input": {
    //   color: "#A2A2A2",
    // },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      fontSize: "14px",
      padding: 13,
      borderRadius: "8px",
      backgroundColor: "#fff",
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
  },
  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
      borderRadius: "8px",
      backgroundColor: "#fff",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: "14px",
    },
  },
  textField2: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: "14px 14px 14px 2px",
    },
  },
  backgroundStyle: {
    background: "#fff",
    borderRadius: "8px",
  },

  tableContainerStyle: {
    background: "white",
    padding: "10px 20px",
    borderRadius: "4px",
    boxShadow: "0px 0px 2px 1px rgba(0, 0, 0, .05)",
  },
  tableStyle: {
    "& tbody tr:hover": {
      background: "#FCF1EC",
      borderRadius: "8px",
      padding: 10,
    },
    "& th": {
      color: "#19181666",
      // padding:0,
    },
    "& td": {
      // borderBottom: "none !important",
      // padding:0
      // padding: "0px 24px 6px 16px",
    },
    "& tr:last-child td": {
      borderBottom: "none !important",
    },
  },
  pageNoStyle: {
    background: "#9c3836",
    padding: "5px 10px",
    margin: "0 22px",
    cursor: "pointer",
    borderRadius: "8px",
  },
  pageNoImageStyle: {
    padding: "5px 10px",
    cursor: "pointer",
    borderRadius: "8px",
  },
  success_button: {
    background: "#2ecc71",
    color: "#fff",
    marginRight: 7,
    "&:hover": {
      background: "#2ecc71",
      color: "#fff",
    },
  },
}));

const TransferRequest = () => {
  const classes = useStyles();
  let history = useHistory();
  const [status, setStatus] = useState(0);
  const [transfer, setTransfer] = useState([]);
  const [transactionNumber, setTransactionNumber] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const { login, glob_pay_agent_auth, logout } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();

  const [open, setOpen] = React.useState(false);
  const [accept, setAccept] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const getTransaction = async () => {
    setLoading(true);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    try {
      let res = await axios({
        url: `/api/v1/private/agent/fetch-transfer-requests?page=${page}`,
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      console.log("response", res.data.data);

      setTransfer(res.data.data.content);
      setPage(res.data.data.pageable.pageNumber);
      setTotalRows(res.data.data.totalElements);
      setRowsPerPage(res.data.data.pageable.pageSize);
    } catch (error) {
      console.log("err:::", error.response);
    }
    setLoading(false);
  };

  const handleUpdate = async () => {
    setLoading(true);
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    try {
      let data = {
        transactionNumber,
        status: accept,
      };

      // return console.log("data", data);
      let res = await axios({
        url: `/api/v1/private/agent/process-transfer-requests`,
        method: "put",
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      handleClose();
      setTransactionNumber("");
      setRefresh(!refresh);
      enqueueSnackbar("Status  successfully updated!", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
        TransitionComponent: Slide,
      });
    } catch (error) {
      let er = error.response && error.response.data.errors.toString();

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }
    setLoading(false);
  };

  const handleChangePage = async (event, newPage) => {
    console.log("new page", newPage);
    setPage(newPage);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getTransaction();
    console.log("changes");
  }, [page, refresh]);

  return (
    <div>
      <Typography variant="h5" className={classes.marginBottomStyle}>
        Transfer Request
      </Typography>

      <TableContainer
        className={`${classes.tableContainerStyle} ${classes.marginBottomStyle}`}
      >
        <Table className={classes.tableStyle} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell> Date & Time</TableCell>
              <TableCell>Transaction ID</TableCell>
              <TableCell>Collection Point</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>

          {!loading && (
            <TableBody>
              {transfer.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>
                    {moment(item.createdAt).format("DD MMMM YYYY HH:mm:ss A")}
                  </TableCell>
                  <TableCell>{item.transactionNumber}</TableCell>
                  <TableCell>{item.collectionPoint}</TableCell>
                  <TableCell>
                    {item.transaction &&
                      item.transaction.amountToTransfer.toFixed(2)}
                    <strong style={{ marginLeft: 5 }}>
                      {item.transaction && item.transaction.fromCurrency}
                    </strong>
                  </TableCell>
                  <TableCell>
                    <img src={IconForwardArrow} alt="" />
                  </TableCell>
                  <TableCell>
                    {item.transaction &&
                      item.transaction.amountReceivable.toFixed(2)}
                    <strong style={{ marginLeft: 5 }}>
                      {item.transaction && item.transaction.toCurrency}
                    </strong>
                  </TableCell>
                  <TableCell>
                    {item.status === "AwaitingAgentConfirmation" ? (
                      <>
                        <Button
                          variant="contained"
                          className={classes.success_button}
                          size="small"
                          onClick={(e) => {
                            setTransactionNumber(item.transactionNumber);
                            setAccept(true);
                            handleClickOpen();
                          }}
                        >
                          <strong>Accept</strong>
                        </Button>
                        <Button
                          variant="outlined"
                          color="secondary"
                          size="small"
                          onClick={(e) => {
                            setTransactionNumber(item.transactionNumber);
                            setAccept(false);
                            handleClickOpen();
                          }}
                        >
                          <strong>Decline</strong>{" "}
                        </Button>
                      </>
                    ) : (
                      item.status
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
          <TableBody>
            <TableRow>
              <TableCell colSpan={7} style={{ textAlign: "center" }}>
                {loading ? (
                  <>
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                    <Skeleton animation="wave" height="50px" />
                  </>
                ) : null}
                {!loading && transfer.length < 1 && " No record Found"}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        component="div"
        count={totalRows}
        page={page}
        onChangePage={handleChangePage}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10]}
      />
      {/* <span className={classes.pageNoStyle}>{page}</span> */}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {accept ? "Are you sure to Accept?" : "Are you sure to Decline?"}
        </DialogTitle>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          {accept ? (
            <Button
              onClick={handleUpdate}
              variant="contained"
              color="primary"
              className={classes.success_button}
            >
              Yes
            </Button>
          ) : (
            <Button
              onClick={handleUpdate}
              variant="contained"
              color="secondary"
            >
              Yes
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TransferRequest;
